var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.total > 0)?_c('b-badge',{staticClass:"ml-1 number-badge rounded-pill",attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.total > 10 ? '10+' : _vm.total)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }